import React, { useState } from 'react';
import { View, Text } from 'react-native';
import theme from '../../theme';
import Button from './Button';
import { LeadCaptureDialog } from './LeadCaptureDialog';

export function CTA(props) {

  const submitHandler = props.submitHandler;
  const responseStatus = props.responseStatus;
  const heading = props.heading;
  const buttonLabel = props.buttonLabel;
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <View
      style={{
        paddingVertical: 64,
        paddingHorizontal: 48,
        backgroundColor: theme.colors.gray950,
        alignItems: 'center',
      }}
    >
      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: theme.typography.size['2xl'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xl'], 'tight'),
          color: theme.colors.textInverse,
          marginBottom: 24,
          textAlign: 'center',
        }}
      >
        {heading}
      </Text>
      <Button variant="primary" size="lg" onPress={() => setDialogOpen(true)}>
        {buttonLabel}
      </Button>
      <LeadCaptureDialog visible={dialogOpen} onClose={() => setDialogOpen(false)} onSubmit={submitHandler} responseStatus={responseStatus}/>
    </View>
  );
}